import { render, staticRenderFns } from "./MedicalSpecialtyList.vue?vue&type=template&id=eec0b6ce&scoped=true&lang=pug"
import script from "./MedicalSpecialtyList.vue?vue&type=script&lang=js"
export * from "./MedicalSpecialtyList.vue?vue&type=script&lang=js"
import style0 from "./MedicalSpecialtyList.vue?vue&type=style&index=0&id=eec0b6ce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eec0b6ce",
  null
  
)

export default component.exports